import styled from "styled-components"
import { AnimatePresence, motion } from "framer-motion"

import SiteImage from "assets/images/location/site-map.jpg"

export default function LocationSite() {
  return (
    <AnimatePresence>
      <Holder
        initial="initial"
        animate="animate"
        exit="hidden"
        variants={{
          initial: {
            y: 40,
            opacity: 0
          },
          animate: {
            y: 0,
            opacity: 1
          },
          exit: {
            y: 40,
            opacity: 1
          }
        }}
        transition={{ duration: 0.6 }}
      ></Holder>
    </AnimatePresence>
  )
}

const Holder = styled(motion.div)`
  width: 100%;
  height: 100%;
  background-image: url(${SiteImage});
  background-size: auto 100%;
  background-position: center;
  background-repeat: no-repeat;
`
